import React from 'react';
import styles from './DarkModeSwitch.module.scss';

const DarkModeSwitch = ({ darkMode, toggleDarkMode }) => {
  return (
    <div className={styles.switch}>
      <input
        type="checkbox"
        id="darkModeToggle"
        checked={darkMode}
        onChange={toggleDarkMode}
      />
      <label htmlFor="darkModeToggle">
        <span className={styles.slider}></span>
      </label>
    </div>
  );
};

export default DarkModeSwitch;